<template>
  <div>
    <div
      @click="handleClick(item.cid)"
      @dblclick="handleDblclick(item.cid)"
      :class="['clientItem-wrap',{active:item.cid===activeCid}]"
      v-for="(item,index) in listData" :key="index"
    >
      <div class="line-wrap">
        <span>{{item.name}}</span>
        <a-icon v-show="item.cid===activeCid" type="check"/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'clientBox',
  data () {
    return {}
  },
  created () {
  },
  props: {
    activeCid: {
      type: Number,
      default: 0
    },
    listData: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    handleDblclick (cid) {
      this.handleClick(cid)
      this.$emit('login')
    },
    handleClick (cid) {
      this.$emit('change', this.listData.filter(customer => customer.cid === cid)[0])
    }
  }
}
</script>

<style scoped lang='less'>
  @import '../../common/styles/varibles.less';
  @import '../../common/styles/mixins.less';

  .clientItem-wrap {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 364px;
    height: 36px;
    line-height: 36px;
    font-family: @pr;
    font-size: 14px;
    color: @bc;
    background-color: @w;
    padding-left: 16px;
    .line-wrap {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .anticon-check {
        color: @link;
        transform: translate(-20px, 0);
      }
    }
    &.active {
      background-color: @f567;
    }
    ant-icon {
      position: absolute;
      left: 20px;
    }
  }
</style>
